import { render, staticRenderFns } from "./TeacherReport.vue?vue&type=template&id=73f0f481&"
import script from "./TeacherReport.vue?vue&type=script&lang=js&"
export * from "./TeacherReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports